import { render, staticRenderFns } from "./TermsAcceptanceModal.vue?vue&type=template&id=67cd9613&scoped=true"
import script from "./TermsAcceptanceModal.vue?vue&type=script&lang=js"
export * from "./TermsAcceptanceModal.vue?vue&type=script&lang=js"
import style0 from "./TermsAcceptanceModal.vue?vue&type=style&index=0&id=67cd9613&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cd9613",
  null
  
)

export default component.exports